import React, { SVGProps } from 'react'
export const FourthActiveCenterSvg = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="36"
    fill="none"
    viewBox="0 0 74 36"
    preserveAspectRatio="none"
    {...props}
  >
    <path
      fill="currentColor"
      d="M38.945.659C27.237-.996 4.739.989 0 .989v34.98h37.55c9.516 0 30.969.031 36.45.031V1C71.07.575 66.21.516 64.407.925c-5.575.552-16.096 1.058-25.462-.266Z"
    />
  </svg>
)
